export const isAppLoaded = (state) => state.isAppLoaded
export const isAppModuleLoaded = (state) => state.isAppModuleLoaded
export const getAppAsideMinimizeState = (state) => state.appAsideMinimize






